export default "__VITE_ASSET__Du7ayjVT__"